var _line, _line2, _line3, _line4, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmissionTitleDut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4.64062,
    x2: 14.1429,
    y2: 4.64062,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.6484,
    y1: 9,
    x2: 13.6484,
    y2: 5.14286,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.789062,
    y1: 9,
    x2: 0.789062,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 7.21094,
    x2: 14.1429,
    y2: 7.21094,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.85603,
    cy: 2.56696,
    r: 0.785714,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89844 1.78125H11.5713C12.5418 1.78136 13.3543 2.45024 13.5781 3.35156H6.89844C6.4648 3.35154 6.11328 3.00005 6.11328 2.56641C6.11334 2.13282 6.46485 1.78127 6.89844 1.78125Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionTitleDut);
export default __webpack_public_path__ + "static/media/admission-title-dut.b9508c68ff4cd5b9a6d1da6c38059294.svg";
export { ForwardRef as ReactComponent };